import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Form, FormGroup } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Blue_Round_Btn from "../../common-btn/blue_round_btn/Blue_Round_Btn";
import Red_Round_Btn from "../../common-btn/red_round_btn/Red_Round_Btn";
import "./Logout_Modal.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { getAllCart } from "../../../../features/cart/cartSlice";
import { getAllWishlist } from "../../../../features/wishlist/wishlistSlice";
import { setIsSignedOut } from "../../../../features/auth/authSlice";
import Success_Modal from "../success_modal/Success_Modal";
const Logout_Modal = (props) => {
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const countries = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const onSubmit = (data) => {
    console.log("Form submitted:", data);
    props?.onHide();
  };

  const [showLogin, setShowLogin] = useState(false);
  const is_signin = useSelector((state) => state.auth.is_signin);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleCloseLogout = async () => {
    Cookies.remove("bapat_optics_security");
    dispatch(setIsSignedOut());
    setShowLogin(true);
    props?.onHide();

    dispatch(getAllCart(is_signin));
    dispatch(getAllWishlist());

    setTimeout(() => {
      navigate("/");
      setShowLogin(false);
    }, 2000);
    // const res = await dispatch(logout());

    // if (res.meta?.requestStatus === "fulfilled") {

    //   //   setShow(false);
    //   //
    // } else if (res.meta?.requestStatus === "rejected") {
    //   console.log("Error:", res.payload || "User info fetch failed");
    // }
  };
  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Reschedule_Appointment_Modal Logout_Modal"
      >
        <Modal.Body>
          <div className="reschedule_form">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <p className="logout_text">{props?.questionText}</p>

              <div className="btn_holder">
                <Blue_Round_Btn
                  btnText="Log Out"
                  type="submit"
                  onClick={() => {
                    handleCloseLogout();
                  }}
                />
                <Red_Round_Btn
                  btnText={"Close"}
                  onClick={() => {
                    props?.onHide();
                  }}
                />
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      <Success_Modal
        show={showLogin}
        onHide={() => {
          setShowLogin(false);
        }}
        successText="LogOut Successful!"
      />
    </>
  );
};

export default Logout_Modal;
